document.addEventListener('DOMContentLoaded', function() {
    // Remove all <style> tags inside .shoppyc-widget within the desired selector
    const widgets = document.querySelectorAll('.custom-product-sidebar__stores-availability-btn .shoppyc-widget');
    widgets.forEach(widget => {
        // Remove all existing <style> tags
        widget.querySelectorAll('style').forEach(styleTag => {
        styleTag.remove();
        });
        // Observe future additions of <style> tags
        const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
            if (node.tagName === 'STYLE') {
                node.remove();
            }
            });
        });
        });
        observer.observe(widget, { childList: true });
    });

    const productButtons = document.querySelectorAll('.product-btn');
    const sizeSidebar = document.querySelector('.custom-product-sidebar.custom-product-sidebar__sizes');
    // storesSidebar code is commented out in the Liquid file, but we keep the variable for potential future use
    // please search the project for "custom-product-sidebar__content-stores" to see where it is used
    const storesSidebar = document.querySelector('.custom-product-sidebar__content-stores');
    const closeSizeSidebarButtons = document.querySelectorAll('[data-action="close-size-sidebar"]');
    const sizeButtons = document.querySelectorAll('.custom-product-sidebar__size[data-variant-id]');
    const toggleSizeGuideButtons = document.querySelectorAll('[data-action="toggle-size-guide"]');
    const sizesContent = document.querySelector('.custom-product-sidebar__content-sizes');
    const guideContent = document.querySelector('.custom-product-sidebar__content-guide');
    const openStoresButtons = document.querySelectorAll('.js-open-stores-alocation');
    const storeSelect = document.querySelector('.custom-product-sidebar__guide-select');

    if (productButtons.length > 0) {
        productButtons.forEach(function(productButton) {
            productButton.addEventListener('click', function() {
                if(!productButton.classList.contains('bis-button')) {
                    openSizeSidebar();
                }
            });
        });
    }

    function openSizeSidebar() {
        if (sizeSidebar) {
            sizeSidebar.classList.add('is-active');
            document.body.classList.add('product-sidebar-open');
        }
    }

    // Global utility functions for use in other scripts
    window.closeSizeSidebar = function() {
        const sizeSidebar = document.querySelector('.custom-product-sidebar.custom-product-sidebar__sizes');
        const sizesContent = document.querySelector('.custom-product-sidebar__content-sizes');
        const guideContent = document.querySelector('.custom-product-sidebar__content-guide');
        const storesSidebar = document.querySelector('.custom-product-sidebar__content-stores');
        const storeSelect = document.querySelector('.custom-product-sidebar__guide-select');
        if (sizeSidebar) {
            sizeSidebar.classList.remove('is-active');
            document.body.classList.remove('product-sidebar-open');
            if (sizesContent) {
                sizesContent.classList.remove('hidden');
            }
            if (guideContent) {
                guideContent.classList.add('hidden');
            }
            if (storesSidebar) {
                storesSidebar.classList.add('hidden');
            }
            if (storeSelect) {
                storeSelect.value = '';
            }
        }
    }

    if (closeSizeSidebarButtons.length > 0) {
        closeSizeSidebarButtons.forEach(button => {
            button.addEventListener('click', closeSizeSidebar);
        });
    }

    if (sizeSidebar) {
        sizeSidebar.addEventListener('click', function(e) {
            if (e.target === sizeSidebar) {
                closeSizeSidebar();
            }
        });
    }

    if (toggleSizeGuideButtons.length > 0 && sizesContent && guideContent) {
        toggleSizeGuideButtons.forEach(button => {
            button.addEventListener('click', function() {
                if (!sizeSidebar.classList.contains('is-active')) {
                    openSizeSidebar();
                }
                sizesContent.classList.add('hidden');
                guideContent.classList.remove('hidden');
                if (storesSidebar) {
                    storesSidebar.classList.add('hidden');
                }
            });
        });
    }

    if (openStoresButtons.length > 0) {
        openStoresButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                if (sizeSidebar) {
                    sizeSidebar.classList.add('is-active');
                    document.body.style.overflow = 'hidden';
                }
                if (sizesContent) {
                    sizesContent.classList.add('hidden');
                }
                if (guideContent) {
                    guideContent.classList.add('hidden');
                }
                if (storesSidebar) {
                    storesSidebar.classList.remove('hidden');
                }
            });
        });
    }

    // Handle store availability display
    if (storeSelect) {
        storeSelect.addEventListener('change', function() {
            const selectedVariantId = this.value;
            if (selectedVariantId) {
                checkVariantAvailability(selectedVariantId);
            }
        });
    }

    // Add to cart functionality
    if (sizeButtons.length > 0) {
        sizeButtons.forEach(button => {
            button.addEventListener('click', function() {
                const variantId = this.getAttribute('data-variant-id');
                const productId = this.getAttribute('data-product-id');

                if (variantId && productId) {
                    addToCart(variantId, productId);
                }
            });
        });
    }

    window.updateCartBubble = function() {
        fetch('/?section_id=cart-icon-bubble')
            .then(response => {
                return response.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newBubble = doc.querySelector('.cart-count-bubble');
                const currentBubbleContainer = document.querySelector('#cart-icon-bubble');

                if (newBubble && currentBubbleContainer) {
                    currentBubbleContainer.innerHTML = '';
                    const sanitizedBubble = newBubble.cloneNode(true);
                    if (window.DOMPurify && sanitizedBubble.innerHTML) {
                      sanitizedBubble.innerHTML = window.DOMPurify.sanitize(sanitizedBubble.innerHTML);
                    }
                    currentBubbleContainer.appendChild(sanitizedBubble);
                }
            })
            .catch(error => {
                console.error('[updateCartBubble] error', error);
            });
    }

    window.updateCartDrawer = function(callback) {
        fetch('/cart?section_id=cart-drawer')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newDrawer = doc.querySelector('cart-drawer');
                const currentDrawer = document.querySelector('cart-drawer');
                if (newDrawer && currentDrawer) {
                    currentDrawer.replaceWith(newDrawer);
                }
                if (typeof callback === 'function') {
                    callback();
                }
                // Open cart after closing sidebar
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.open();
                }
            });
    }

    window.addToCart = function(variantIds) {
        let items = [];
        if (Array.isArray(variantIds)) {
            items = variantIds.filter(Boolean).map(id => ({ id, quantity: 1 }));
        } else if (variantIds) {
            items = [{ id: variantIds, quantity: 1 }];
        }
        if (!items.length) return;
        const formData = { items };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(_ => {
            updateCartDrawer(() => {
                closeSizeSidebar();
                updateCartBubble();
            });
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    function checkVariantAvailability(variantId) {
        if (!variantId) return;

        const variantSectionUrl = `/variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
            .then((response) => response.text())
            .then((text) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const section = doc.querySelector('.shopify-section');

                if (section) {
                    const storeList = document.querySelector('.custom-product-sidebar__stores-list');
                    if (storeList) {
                        storeList.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(section.innerHTML) : section.innerHTML;
                    }
                }
            })
            .catch((error) => {
                console.error('Error checking availability:', error);
            });
    }

    // Product image gallery: Embla carousel on mobile, CSS grid on desktop (>= 1024px).
    function initProductGallery() {
      const viewport = document.querySelector('.product-gallery__viewport');
      if (!viewport) return;

      const EmblaCarousel = window.EmblaCarousel;
      if (!EmblaCarousel) {
        console.error('Embla Carousel not loaded');
        return;
      }

      const container = viewport.querySelector('.product-gallery__container');
      const slides = container
        ? Array.from(container.querySelectorAll('.product-gallery__slide'))
        : [];
      const nav = viewport.querySelector('.product-gallery__nav');
      const prevBtn = viewport.querySelector('.product-gallery__nav-btn--prev');
      const nextBtn = viewport.querySelector('.product-gallery__nav-btn--next');
      const dotsContainer = viewport.querySelector('.product-gallery__dots');

      const DESKTOP_BREAKPOINT = 1024;
      const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
      // watchResize is disabled: the creative transforms below shift each slide's
      // bounding rect, which would corrupt Embla's automatic re-measurement. Resizes
      // are handled manually in sync() where transforms are cleared before reInit().
      const options = {
        loop: true,
        align: 'start',
        watchResize: false,
      };

      let embla = null;
      let dotButtons = [];

      // Stacked-cards transition. dLoop is the loop-aware distance from the current
      // slide (drives the visual stack); dLinear compensates Embla's container translate.
      const PARALLAX = 20;
      const stackedScreenOffset = (d) => {
        if (d >= 1) return 0;
        if (d >= 0) return -PARALLAX * d;
        if (d > -1) return -100 * d;
        return 100;
      };
      const applyCreative = () => {
        if (!embla) return;
        const snaps = embla.scrollSnapList();
        const snapCount = snaps.length;
        if (snapCount <= 1) return;
        const engine = embla.internalEngine();
        const isLoop = !!(engine.options && engine.options.loop);
        const range = isLoop ? snapCount : snapCount - 1;
        let progress = embla.scrollProgress();
        if (!isLoop) progress = Math.min(Math.max(progress, 0), 1);
        const pos = progress * range;
        const loopPoints =
          isLoop && engine.slideLooper ? engine.slideLooper.loopPoints : [];
        slides.forEach((slide, i) => {
          const snap = snaps[i];
          const dtLinear = snap - progress;
          let dtLoop = dtLinear;
          loopPoints.forEach((lp) => {
            const target = lp.target();
            if (lp.index === i && target !== 0) {
              dtLoop =
                Math.sign(target) === -1
                  ? snap - (1 + progress)
                  : snap + (1 - progress);
            }
          });
          const dLinear = -range * dtLinear;
          const dLoop = -range * dtLoop;
          const translate = stackedScreenOffset(dLoop) + dLinear * 100;
          slide.style.transform = `translateX(${translate}%)`;
          slide.style.zIndex = String(Math.round(pos - dLoop));
        });
      };

      const clearCreative = () => {
        slides.forEach((slide) => {
          slide.style.transform = '';
          slide.style.zIndex = '';
        });
      };

      const onPrev = () => embla && embla.scrollPrev();
      const onNext = () => embla && embla.scrollNext();

      const updateNav = () => {
        if (!embla) return;
        const canPrev = embla.canScrollPrev();
        const canNext = embla.canScrollNext();
        if (prevBtn) prevBtn.disabled = !canPrev;
        if (nextBtn) nextBtn.disabled = !canNext;
        if (nav) nav.hidden = !canPrev && !canNext;
      };

      const buildDots = () => {
        if (!dotsContainer || !embla) return;
        dotsContainer.innerHTML = '';
        dotButtons = embla.scrollSnapList().map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-gallery__dot';
          dot.setAttribute('aria-label', String(index + 1));
          dot.addEventListener('click', () => embla.scrollTo(index));
          dotsContainer.appendChild(dot);
          return dot;
        });
        dotsContainer.hidden = dotButtons.length <= 1;
      };

      const updateDots = () => {
        if (!dotButtons.length) return;
        const selected = embla.selectedScrollSnap();
        dotButtons.forEach((dot, index) => {
          const isSelected = index === selected;
          dot.classList.toggle('is-selected', isSelected);
          if (isSelected) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const onSelect = () => {
        // Safety: navigation is blocked while zoomed, but reset just in case.
        if (fsZoomed) zoomOut();
        updateNav();
        updateDots();
      };

      const onScroll = () => {
        if (!prefersReducedMotion) applyCreative();
      };

      const create = () => {
        if (embla) return;
        embla = EmblaCarousel(viewport, options);
        if (prevBtn) prevBtn.addEventListener('click', onPrev);
        if (nextBtn) nextBtn.addEventListener('click', onNext);
        embla.on('select', onSelect);
        embla.on('scroll', onScroll);
        embla.on('reInit', () => {
          buildDots();
          onSelect();
          onScroll();
        });
        buildDots();
        onSelect();
        onScroll();
      };

      const destroy = () => {
        if (!embla) return;
        if (prevBtn) prevBtn.removeEventListener('click', onPrev);
        if (nextBtn) nextBtn.removeEventListener('click', onNext);
        embla.destroy();
        embla = null;
        clearCreative();
        if (container) container.style.transform = '';
        if (dotsContainer) {
          dotsContainer.innerHTML = '';
          dotButtons = [];
        }
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
      };

      const sync = () => {
        if (isDesktop()) {
          if (fsOpen) closeFullscreen();
          destroy();
        } else if (!embla) {
          create();
        } else {
          // Still mobile: re-measure for the new viewport width. Clear transforms
          // first so Embla reads untransformed slide rects; reInit re-applies them.
          clearCreative();
          embla.reInit();
        }
      };

      // -------------------------------------------------------------------
      // Fullscreen tap-to-zoom (mobile). Single tap opens a fullscreen fit
      // view; another tap zooms toward the tapped point; a further tap zooms
      // out. While zoomed the image can be panned and Embla dragging is
      // blocked so slides don't change. Navigation (swipe/dots) stays active
      // in the fit view. Desktop keeps its own GSAP hover zoom.
      // -------------------------------------------------------------------
      const zoomCloseBtn = viewport.querySelector('.product-gallery__zoom-close');
      const ZOOM_SCALE = 2.5;
      const TAP_MOVE_THRESHOLD = 10;
      const TAP_TIME_THRESHOLD = 300;
      const ZOOM_OPEN_CLASS = 'product-image-zoom-open';
      const ZOOMED_CLASS = 'product-image-zoomed';

      let fsOpen = false;
      let fsZoomed = false;
      let activeZoomEl = null;
      let activeImg = null;
      let scale = 1;
      let panX = 0;
      let panY = 0;
      let panClampRaf = 0;

      const MIN_SCALE = 1;
      const MAX_SCALE = 4;
      const SWIPE_NAV_THRESHOLD = 45;

      let lastPanEndTime = 0;

      // Unified pointer handling (tap / pan / pinch / swipe). While fullscreen
      // we own every gesture so Embla dragging and native pinch/scroll never
      // fight our transform (which caused the pinch glitches).
      const pointers = new Map();
      let gesture = null; // 'idle' | 'pan' | 'pinch'
      let downX = 0;
      let downY = 0;
      let downTime = 0;
      let downMoved = false;
      let startPanX = 0;
      let startPanY = 0;
      let pinchStartDist = 0;
      let pinchStartScale = 1;
      let pinchLocalX = 0;
      let pinchLocalY = 0;
      let moveUpBound = false;

      function applyZoomTransform() {
        if (!activeZoomEl) return;
        activeZoomEl.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${scale})`;
      }

      // Screen-space rect of the painted bitmap for object-fit: contain,
      // not the img border box (avoids clamping against letterboxed areas).
      function getImgPaintedClientRect(img) {
        const full = img.getBoundingClientRect();
        const objectFit = getComputedStyle(img).objectFit;
        if (objectFit !== 'contain' && objectFit !== 'scale-down') return full;

        const natW = img.naturalWidth;
        const natH = img.naturalHeight;
        const elW = img.offsetWidth;
        const elH = img.offsetHeight;
        if (!(natW > 0 && natH > 0 && elW > 0 && elH > 0)) return full;

        let r = Math.min(elW / natW, elH / natH);
        if (objectFit === 'scale-down') r = Math.min(1, r);

        const drawW = natW * r;
        const drawH = natH * r;
        if (drawW >= elW - 0.5 && drawH >= elH - 0.5) return full;

        const sx = full.width / elW;
        const sy = full.height / elH;
        const cx = full.left + full.width / 2;
        const cy = full.top + full.height / 2;
        const w = drawW * sx;
        const h = drawH * sy;
        const left = cx - w / 2;
        const top = cy - h / 2;
        return { left, top, width: w, height: h, right: left + w, bottom: top + h };
      }

      function clampPan() {
        if (!fsZoomed || !activeImg) return;
        const view = viewport.getBoundingClientRect();
        const ir = getImgPaintedClientRect(activeImg);
        const eps = 0.5;
        let dx = 0;
        let dy = 0;

        if (ir.width >= view.width - eps) {
          if (ir.left > view.left + eps) dx = view.left - ir.left;
          else if (ir.right < view.right - eps) dx = view.right - ir.right;
        } else {
          dx = view.left + view.width / 2 - (ir.left + ir.width / 2);
        }

        if (ir.height >= view.height - eps) {
          if (ir.top > view.top + eps) dy = view.top - ir.top;
          else if (ir.bottom < view.bottom - eps) dy = view.bottom - ir.bottom;
        } else {
          dy = view.top + view.height / 2 - (ir.top + ir.height / 2);
        }

        if (Math.abs(dx) > 0.01 || Math.abs(dy) > 0.01) {
          panX += dx;
          panY += dy;
          applyZoomTransform();
        }
      }

      function schedulePanClamp() {
        if (!fsZoomed) return;
        if (panClampRaf) cancelAnimationFrame(panClampRaf);
        panClampRaf = requestAnimationFrame(() => {
          panClampRaf = 0;
          clampPan();
        });
      }

      function loadHiRes(zoomEl, img) {
        const zoomSrc = zoomEl.getAttribute('data-zoom-src');
        if (zoomSrc && !img.dataset.originalSrc) {
          // Preserve currently displayed sources so we can restore them on zoom-out.
          img.dataset.originalSrc = img.currentSrc || img.src;
          img.dataset.originalSrcset = img.srcset || '';

          // Decode the hi-res off-DOM first, then swap. Swapping the visible <img>
          // while the new bitmap is still decoding leaves the element with no painted
          // image for a few frames (white flash), because these images use
          // decoding="async". Waiting for decode makes the swap instant.
          const swapToZoom = () => {
            // Bail if the user zoomed back out before the hi-res was ready.
            if (!img.dataset.originalSrc) return;
            img.srcset = '';
            img.src = zoomSrc;
            img.addEventListener('load', schedulePanClamp, { once: true });
          };

          const preloader = new Image();
          preloader.src = zoomSrc;
          if (typeof preloader.decode === 'function') {
            preloader.decode().then(swapToZoom).catch(swapToZoom);
          } else {
            preloader.onload = swapToZoom;
            preloader.onerror = swapToZoom;
          }
        }
      }

      function restoreSrc(img) {
        if (img && img.dataset.originalSrc) {
          img.src = img.dataset.originalSrc;
          img.srcset = img.dataset.originalSrcset || '';
          delete img.dataset.originalSrc;
          delete img.dataset.originalSrcset;
        }
      }

      function zoomInAt(zoomEl, img, cx, cy) {
        activeZoomEl = zoomEl;
        activeImg = img;
        scale = ZOOM_SCALE;
        const view = viewport.getBoundingClientRect();
        const ox = cx - (view.left + view.width / 2);
        const oy = cy - (view.top + view.height / 2);
        panX = ox * (1 - scale);
        panY = oy * (1 - scale);
        loadHiRes(zoomEl, img);
        if (!prefersReducedMotion) activeZoomEl.style.transition = 'transform 0.3s ease';
        applyZoomTransform();
        fsZoomed = true;
        document.body.classList.add(ZOOMED_CLASS);
        schedulePanClamp();
      }

      function zoomOut() {
        if (!fsZoomed) return;
        fsZoomed = false;
        document.body.classList.remove(ZOOMED_CLASS);
        scale = 1;
        panX = 0;
        panY = 0;
        if (activeZoomEl) {
          if (!prefersReducedMotion) activeZoomEl.style.transition = 'transform 0.3s ease';
          activeZoomEl.style.transform = '';
        }
        restoreSrc(activeImg);
        activeZoomEl = null;
        activeImg = null;
      }

      function openFullscreen() {
        if (fsOpen || isDesktop()) return;
        fsOpen = true;
        document.body.classList.add(ZOOM_OPEN_CLASS);
        if (!prefersReducedMotion) applyCreative();
      }

      function closeFullscreen() {
        if (!fsOpen) return;
        if (fsZoomed) zoomOut();
        fsOpen = false;
        document.body.classList.remove(ZOOM_OPEN_CLASS);
        if (!prefersReducedMotion) applyCreative();
      }

      function ensureActiveEl() {
        const idx = embla ? embla.selectedScrollSnap() : 0;
        const slide = slides[idx];
        const activeSlide = activeZoomEl
          ? activeZoomEl.closest('.product-gallery__slide')
          : null;
        // Keep the current element only if it actually belongs to the selected
        // slide; otherwise it's stale (e.g. after a pinch-dezoom + arrow nav) and
        // must be refreshed so gestures act on the visible slide.
        if (activeZoomEl && activeImg && activeSlide === slide) {
          return;
        }
        const zoomEl = slide ? slide.querySelector('.product-gallery__zoom') : null;
        const img = zoomEl ? zoomEl.querySelector('img') : null;
        if (zoomEl && img) {
          activeZoomEl = zoomEl;
          activeImg = img;
        }
      }

      function distance(a, b) {
        return Math.hypot(a.x - b.x, a.y - b.y);
      }

      function midpoint(a, b) {
        return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      }

      function setZoomedFlag(on) {
        if (fsZoomed === on) return;
        fsZoomed = on;
        document.body.classList.toggle(ZOOMED_CLASS, on);
      }

      function bindMoveUp() {
        if (moveUpBound) return;
        moveUpBound = true;
        window.addEventListener('pointermove', onPointerMove, { passive: false });
        window.addEventListener('pointerup', onPointerUp);
        window.addEventListener('pointercancel', onPointerUp);
      }

      function unbindMoveUp() {
        if (!moveUpBound) return;
        moveUpBound = false;
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', onPointerUp);
        window.removeEventListener('pointercancel', onPointerUp);
      }

      function isControlTarget(target) {
        return !!(
          target.closest('.product-gallery__dots') ||
          target.closest('.product-gallery__nav') ||
          target.closest('.product-gallery__zoom-close')
        );
      }

      function beginPinch() {
        const pts = [...pointers.values()];
        gesture = 'pinch';
        downMoved = true; // a pinch is never a tap
        ensureActiveEl();
        pinchStartDist = distance(pts[0], pts[1]) || 1;
        pinchStartScale = scale;
        const mid = midpoint(pts[0], pts[1]);
        const view = viewport.getBoundingClientRect();
        const cx = view.left + view.width / 2;
        const cy = view.top + view.height / 2;
        // Content-local anchor under the pinch midpoint (kept fixed while pinching).
        pinchLocalX = (mid.x - cx - panX) / scale;
        pinchLocalY = (mid.y - cy - panY) / scale;
        if (activeZoomEl) activeZoomEl.style.transition = 'none';
      }

      // Capture phase: in fullscreen we intercept every pointer (except overlay
      // controls) so Embla and the browser don't interfere with our gestures.
      function onPointerDownCapture(e) {
        if (!fsOpen) return; // inline: Embla owns the gesture
        if (isControlTarget(e.target)) return; // dots / arrows / close still work
        e.stopPropagation();
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        bindMoveUp();

        if (pointers.size === 1) {
          downX = e.clientX;
          downY = e.clientY;
          downTime = Date.now();
          downMoved = false;
          startPanX = panX;
          startPanY = panY;
          gesture = fsZoomed ? 'pan' : 'idle';
          if (fsZoomed) ensureActiveEl();
        } else if (pointers.size === 2) {
          beginPinch();
        }
      }

      function onPointerMove(e) {
        if (!pointers.has(e.pointerId)) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (e.cancelable) e.preventDefault();

        if (gesture === 'pinch' && pointers.size >= 2) {
          const pts = [...pointers.values()];
          const newDist = distance(pts[0], pts[1]);
          const mid = midpoint(pts[0], pts[1]);
          let next = pinchStartScale * (newDist / pinchStartDist);
          next = Math.max(MIN_SCALE, Math.min(MAX_SCALE, next));
          scale = next;
          ensureActiveEl();
          if (activeZoomEl) activeZoomEl.style.transition = 'none';
          if (scale > 1.01) {
            setZoomedFlag(true);
            if (activeZoomEl && activeImg) loadHiRes(activeZoomEl, activeImg);
            // Focal zoom: keep the point under the fingers fixed...
            const view = viewport.getBoundingClientRect();
            const cx = view.left + view.width / 2;
            const cy = view.top + view.height / 2;
            panX = mid.x - cx - scale * pinchLocalX;
            panY = mid.y - cy - scale * pinchLocalY;
            applyZoomTransform();
            // ...then clamp so the image edges never expose white.
            clampPan();
          } else {
            // At (or below) fit scale the image covers exactly: force centered.
            setZoomedFlag(false);
            panX = 0;
            panY = 0;
            applyZoomTransform();
          }
          return;
        }

        const dx = e.clientX - downX;
        const dy = e.clientY - downY;
        if (Math.abs(dx) > TAP_MOVE_THRESHOLD || Math.abs(dy) > TAP_MOVE_THRESHOLD) {
          downMoved = true;
        }

        if (gesture === 'pan' && fsZoomed) {
          if (activeZoomEl) activeZoomEl.style.transition = 'none';
          panX = startPanX + dx;
          panY = startPanY + dy;
          applyZoomTransform();
          schedulePanClamp();
        }
      }

      function onPointerUp(e) {
        if (!pointers.has(e.pointerId)) {
          if (pointers.size === 0) unbindMoveUp();
          return;
        }
        pointers.delete(e.pointerId);

        if (gesture === 'pinch') {
          if (pointers.size >= 2) return;
          if (scale <= 1.01) {
            zoomOut();
          } else {
            setZoomedFlag(true);
            schedulePanClamp();
          }
          lastPanEndTime = Date.now();
          if (pointers.size === 1) {
            // Keep going with the remaining finger as pan / idle.
            const remaining = [...pointers.values()][0];
            downX = remaining.x;
            downY = remaining.y;
            downTime = Date.now();
            downMoved = true;
            startPanX = panX;
            startPanY = panY;
            gesture = fsZoomed ? 'pan' : 'idle';
          } else {
            gesture = null;
            unbindMoveUp();
          }
          return;
        }

        if (pointers.size > 0) return;

        unbindMoveUp();
        lastPanEndTime = Date.now();
        const elapsed = lastPanEndTime - downTime;
        const dx = e.clientX - downX;
        const dy = e.clientY - downY;

        if (!downMoved && elapsed < TAP_TIME_THRESHOLD) {
          // Single tap toggles zoom.
          if (fsZoomed) {
            zoomOut();
          } else {
            ensureActiveEl();
            if (activeZoomEl && activeImg) {
              zoomInAt(activeZoomEl, activeImg, e.clientX, e.clientY);
            }
          }
        } else if (
          !fsZoomed &&
          Math.abs(dx) > Math.abs(dy) &&
          Math.abs(dx) > SWIPE_NAV_THRESHOLD
        ) {
          // Horizontal swipe in the fit view navigates between images.
          if (dx < 0) {
            if (embla) embla.scrollNext();
          } else if (embla) {
            embla.scrollPrev();
          }
        } else if (fsZoomed) {
          schedulePanClamp();
        }
        gesture = null;
      }

      // Inline tap opens fullscreen; once open, gestures are handled by pointers.
      function onGalleryClick(e) {
        if (isDesktop() || fsOpen) return;
        if (Date.now() - lastPanEndTime < 400) return;
        const zoomEl = e.target.closest('.product-gallery__zoom');
        const img = zoomEl ? zoomEl.querySelector('img') : null;
        if (!zoomEl || !img) return;
        openFullscreen();
      }

      // Embla drags off touchstart/mousedown (bubble phase). Our pointerdown
      // stopPropagation doesn't cover those, so in fullscreen we also block them
      // in capture; otherwise Embla would advance a slide on top of our own
      // swipe navigation (jumping 2 slides at once).
      function blockEmblaDrag(e) {
        if (!fsOpen) return;
        if (isControlTarget(e.target)) return;
        e.stopPropagation();
      }

      viewport.addEventListener('pointerdown', onPointerDownCapture, true);
      viewport.addEventListener('touchstart', blockEmblaDrag, true);
      viewport.addEventListener('mousedown', blockEmblaDrag, true);
      if (container) container.addEventListener('click', onGalleryClick);
      if (zoomCloseBtn) {
        zoomCloseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeFullscreen();
        });
      }

      sync();

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(sync, 150);
        if (fsZoomed) schedulePanClamp();
      });
    }

    initProductGallery();

    // Store zoom event listeners for cleanup
    const zoomEventListeners = new Map();

    // Custom zoom functionality for desktop with GSAP and cursor follow
    function initDesktopZoom() {
        // Check if GSAP is available
        if (typeof gsap === 'undefined') {
            console.warn('GSAP not loaded, falling back to CSS animations');
            return;
        }

        // Clean up existing zoom event listeners
        zoomEventListeners.forEach((listeners, element) => {
            listeners.forEach(({ event, handler }) => {
                element.removeEventListener(event, handler);
            });
        });
        zoomEventListeners.clear();

        if (window.innerWidth >= 1024) {
            const productImages = document.querySelectorAll('.product-info__images .product-gallery__slide img, .product-info__main-img img');

            productImages.forEach(img => {
                let isZoomed = false;
                let scale = 1;
                let canFollow = false;
                let initialZoomX = 0;
                let initialZoomY = 0;
                let zoomCenterX = 0;
                let zoomCenterY = 0;

                // Wrapper to control zoom
                const wrapper = img.parentElement;
                wrapper.style.overflow = 'hidden';
                wrapper.style.cursor = 'zoom-in';

                // Image styling
                img.style.transformOrigin = 'center center';

                // Set initial transform
                gsap.set(img, { scale: 1, x: 0, y: 0 });

                // Function to calculate movement based on cursor position
                function updateImagePosition(e) {
                    if (!isZoomed || !canFollow) return;

                    const wrapperRect = wrapper.getBoundingClientRect();
                    const imgComputedStyle = window.getComputedStyle(img);
                    const imgWidth = parseFloat(imgComputedStyle.width);
                    const imgHeight = parseFloat(imgComputedStyle.height);

                    // Container dimensions
                    const containerWidth = wrapperRect.width;
                    const containerHeight = wrapperRect.height;

                    // Image dimensions with zoom
                    const scaledWidth = imgWidth * scale;
                    const scaledHeight = imgHeight * scale;

                    // Calculate maximum translation limits
                    let maxTranslateX = 0;
                    let maxTranslateY = 0;

                    if (scaledWidth > containerWidth) {
                        maxTranslateX = (scaledWidth - containerWidth) / (2 * scale);
                    }

                    if (scaledHeight > containerHeight) {
                        maxTranslateY = (scaledHeight - containerHeight) / (2 * scale);
                    }

                    // Calculate cursor position relative to wrapper
                    const cursorX = e.clientX - wrapperRect.left;
                    const cursorY = e.clientY - wrapperRect.top;

                    // Calculate offset from zoom center
                    const offsetX = cursorX - zoomCenterX;
                    const offsetY = cursorY - zoomCenterY;

                    // Calculate target position relative to initial zoom position
                    const targetX = initialZoomX - (offsetX * 0.8); // 0.8 is sensitivity factor
                    const targetY = initialZoomY - (offsetY * 0.8);

                    // Apply limits
                    const finalX = Math.max(-maxTranslateX, Math.min(maxTranslateX, targetX));
                    const finalY = Math.max(-maxTranslateY, Math.min(maxTranslateY, targetY));

                    // Use GSAP for smooth following animation
                    gsap.to(img, {
                        x: finalX,
                        y: finalY,
                        duration: 0.1,
                        ease: "none",
                        overwrite: true
                    });
                }

                // Click for zoom
                const clickHandler = function(e) {
                    if (!isZoomed) {
                        // Zoom in
                        scale = 2;
                        isZoomed = true;
                        canFollow = false;
                        wrapper.style.cursor = 'zoom-out';

                        // Calculate zoom position based on click to center the clicked point
                        const wrapperRect = wrapper.getBoundingClientRect();
                        const imgComputedStyle = window.getComputedStyle(img);
                        const imgWidth = parseFloat(imgComputedStyle.width);
                        const imgHeight = parseFloat(imgComputedStyle.height);

                        // Container dimensions
                        const containerWidth = wrapperRect.width;
                        const containerHeight = wrapperRect.height;

                        // Store zoom center for later mouse calculations
                        zoomCenterX = e.clientX - wrapperRect.left;
                        zoomCenterY = e.clientY - wrapperRect.top;

                        // Image dimensions with zoom
                        const scaledWidth = imgWidth * scale;
                        const scaledHeight = imgHeight * scale;

                        // Calculate maximum translation limits
                        let maxTranslateX = 0;
                        let maxTranslateY = 0;

                        if (scaledWidth > containerWidth) {
                            maxTranslateX = (scaledWidth - containerWidth) / (2 * scale);
                        }

                        if (scaledHeight > containerHeight) {
                            maxTranslateY = (scaledHeight - containerHeight) / (2 * scale);
                        }

                        // Calculate the position where the user clicked relative to the image center
                        const clickOffsetX = zoomCenterX - (containerWidth / 2);
                        const clickOffsetY = zoomCenterY - (containerHeight / 2);

                        // Calculate translation to center the clicked point
                        let translateX = -clickOffsetX * (scale - 1) / scale;
                        let translateY = -clickOffsetY * (scale - 1) / scale;

                        // Apply limits to prevent showing white space
                        translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, translateX));
                        translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, translateY));

                        // Store the initial zoom position
                        initialZoomX = translateX;
                        initialZoomY = translateY;

                        // Load full-resolution image for zoom
                        const zoomSrc = wrapper.getAttribute('data-zoom-src');
                        if (zoomSrc) {
                            // Preserve the currently displayed sources so we can restore them on zoom-out.
                            img.dataset.originalSrc = img.currentSrc || img.src;
                            img.dataset.originalSrcset = img.srcset || '';

                            // Decode the hi-res image off-DOM first, then swap. Swapping the visible
                            // <img> src while the new bitmap is still decoding leaves the element with
                            // no painted image for a few frames (white flash), because these gallery
                            // images use decoding="async". Waiting for decode makes the swap instant.
                            const swapToZoom = () => {
                                if (!isZoomed) return;
                                img.srcset = '';
                                img.src = zoomSrc;
                            };

                            const preloader = new Image();
                            preloader.src = zoomSrc;
                            if (typeof preloader.decode === 'function') {
                                preloader.decode().then(swapToZoom).catch(swapToZoom);
                            } else {
                                preloader.onload = swapToZoom;
                                preloader.onerror = swapToZoom;
                            }
                        }

                        // GSAP zoom animation with smooth easing
                        gsap.to(img, {
                            scale: scale,
                            x: translateX,
                            y: translateY,
                            duration: 0.4,
                            ease: "power2.out",
                            onComplete: function() {
                                // Enable mouse following after zoom animation completes
                                canFollow = true;
                            }
                        });

                    } else {
                        // Zoom out
                        scale = 1;
                        isZoomed = false;
                        canFollow = false;
                        initialZoomX = 0;
                        initialZoomY = 0;
                        zoomCenterX = 0;
                        zoomCenterY = 0;
                        wrapper.style.cursor = 'zoom-in';

                        // Restore original image src
                        if (img.dataset.originalSrc) {
                            img.src = img.dataset.originalSrc;
                            img.srcset = img.dataset.originalSrcset || '';
                            delete img.dataset.originalSrc;
                            delete img.dataset.originalSrcset;
                        }

                        // GSAP zoom out animation
                        gsap.to(img, {
                            scale: 1,
                            x: 0,
                            y: 0,
                            duration: 0.4,
                            ease: "power2.out"
                        });
                    }
                };

                img.addEventListener('click', clickHandler);

                // Store event listener for cleanup
                if (!zoomEventListeners.has(img)) {
                    zoomEventListeners.set(img, []);
                }
                zoomEventListeners.get(img).push({ event: 'click', handler: clickHandler });

                // Zoom out on mouse leave
                const mouseLeaveHandler = function() {
                    if (isZoomed) {
                        clickHandler();
                    }
                };
                wrapper.addEventListener('mouseleave', mouseLeaveHandler);

                // Store event listener for cleanup
                if (!zoomEventListeners.has(wrapper)) {
                    zoomEventListeners.set(wrapper, []);
                }
                zoomEventListeners.get(wrapper).push({ event: 'mouseleave', handler: mouseLeaveHandler });

                // Follow cursor when zoomed with no throttling for smoothness
                const mousemoveHandler = function(e) {
                    if (isZoomed && canFollow) {
                        updateImagePosition(e);
                    }
                };

                wrapper.addEventListener('mousemove', mousemoveHandler);

                // Store event listener for cleanup
                if (!zoomEventListeners.has(wrapper)) {
                    zoomEventListeners.set(wrapper, []);
                }
                zoomEventListeners.get(wrapper).push({ event: 'mousemove', handler: mousemoveHandler });

                // Reset zoom on window resize
                const windowResizeHandler = function() {
                    if (window.innerWidth < 1024 && isZoomed) {
                        scale = 1;
                        isZoomed = false;
                        canFollow = false;
                        initialZoomX = 0;
                        initialZoomY = 0;
                        zoomCenterX = 0;
                        zoomCenterY = 0;
                        wrapper.style.cursor = 'zoom-in';
                        gsap.set(img, { scale: 1, x: 0, y: 0 });
                    }
                };

                window.addEventListener('resize', windowResizeHandler);

                // Store event listener for cleanup
                if (!zoomEventListeners.has(window)) {
                    zoomEventListeners.set(window, []);
                }
                zoomEventListeners.get(window).push({ event: 'resize', handler: windowResizeHandler });
            });
        }
    }

    // Initialize zoom on load and resize
    initDesktopZoom();

    // Store the resize handler reference for cleanup
    const resizeHandler = initDesktopZoom;
    window.addEventListener('resize', resizeHandler);

    // Cleanup function to remove event listeners
    function cleanupZoom() {
        window.removeEventListener('resize', resizeHandler);

        // Clean up zoom event listeners
        zoomEventListeners.forEach((listeners, element) => {
            listeners.forEach(({ event, handler }) => {
                element.removeEventListener(event, handler);
            });
        });
        zoomEventListeners.clear();
    }

    // Clean up on page unload
    window.addEventListener('beforeunload', cleanupZoom);

    // Add click handler for product swatches overlay to close sizes sidebar
    document.addEventListener('click', function(e) {
      if (
        e.target &&
        (e.target.id === 'sidebar-overlay-product-swatches' ||
          e.target.closest('#sidebar-overlay-product-swatches'))
      ) {
        const sizesSidebar = document.querySelector('.custom-product-sidebar__sizes');
        if (typeof closeSizeSidebar === 'function') {
          closeSizeSidebar();
        } else if (sizesSidebar) {
          sizesSidebar.classList.remove('is-active');
          document.body.classList.remove('product-sidebar-open');
          // Ensure body scroll is restored as a fallback
          document.body.style.overflow = '';
        }
      }
    });

    document.querySelectorAll('.js-open-traceability').forEach((btn) => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const sizeSidebar = document.querySelector('.custom-product-sidebar.custom-product-sidebar__sizes');
        const sizesContent = document.querySelector('.custom-product-sidebar__content-sizes');
        const guideContent = document.querySelector('.custom-product-sidebar__content-guide');
        const storesSidebar = document.querySelector('.custom-product-sidebar__content-stores');
        const traceabilityContent = document.querySelector('.custom-product-sidebar__content-traceability');

        if (sizeSidebar && !sizeSidebar.classList.contains('is-active')) {
          sizeSidebar.classList.add('is-active');
          document.body.classList.add('product-sidebar-open');
        }
        if (sizesContent) sizesContent.classList.add('hidden');
        if (guideContent) guideContent.classList.add('hidden');
        if (storesSidebar) storesSidebar.classList.add('hidden');
        if (traceabilityContent) traceabilityContent.classList.remove('hidden');
      });
    });

    (function() {
      const originalClose = window.closeSizeSidebar;
      window.closeSizeSidebar = function() {
        if (typeof originalClose === 'function') originalClose();
        const traceabilityContent = document.querySelector('.custom-product-sidebar__content-traceability');
        if (traceabilityContent) traceabilityContent.classList.add('hidden');
      };
    })();


    const fixedContent = document.querySelector('.product-info__fixed-content');
    const buttonsTrigger = document.querySelector('.product-info__content__button');
    const footer = document.querySelector('.mainFooter');

    if (fixedContent && buttonsTrigger) {

        let buttonState = {
            isIntersecting: true,
            top: 0
        };
        let isFooterIntersecting = false;

        const checkStatus = () => {
            const isPastButton = !buttonState.isIntersecting && buttonState.top < 0;
            if (isPastButton && !isFooterIntersecting) {
                fixedContent.classList.add('active');
            } else {
                fixedContent.classList.remove('active');
            }
        };

        new IntersectionObserver((entries) => {
            const entry = entries[0];
            buttonState.isIntersecting = entry.isIntersecting;
            buttonState.top = entry.boundingClientRect.top;
            checkStatus();
        }).observe(buttonsTrigger);

        if (footer) {
            new IntersectionObserver((entries) => {
                isFooterIntersecting = entries[0].isIntersecting;
                checkStatus();
            }).observe(footer);
        }
    }

    const updateTopOffsetStickySection = (section) => {
        section.style.top = `-${section.offsetHeight - window.innerHeight}px`;
    }

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const initStickyBlur = (blurTarget, triggerSection) => {
        const BLUR_START = 0.2;
        const BLUR_END = 0.6;
        const BLUR_AMOUNT = 4;
        let ticking = false;

        const updateBlur = () => {
            const rect = triggerSection.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            const progress = Math.max(0, Math.min(1, 1 - (rect.top / viewportHeight)));

            if (progress > BLUR_START) {
                const normalized = (progress - BLUR_START) / (BLUR_END - BLUR_START);
                const opacity = Math.min(normalized, 1);
                const blurValue = opacity * BLUR_AMOUNT;
                blurTarget.style.setProperty('--sticky-blur-opacity', opacity);
                blurTarget.style.setProperty('--sticky-blur-visibility', 'visible');
                blurTarget.style.setProperty('--sticky-blur-amount', `${blurValue}px`);
            } else {
                blurTarget.style.setProperty('--sticky-blur-opacity', 0);
                blurTarget.style.setProperty('--sticky-blur-visibility', 'hidden');
                blurTarget.style.setProperty('--sticky-blur-amount', '0px');
            }
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                requestAnimationFrame(updateBlur);
                ticking = true;
            }
        }, { passive: true });

        updateBlur();
    };

    const productInfoMain = document.querySelector('.mainProductPDP');
    const productInfoLayer = document.querySelector('.product-info__wrapper__layer');
    if (productInfoLayer) {
        const windowHeight = window.innerHeight;
        gsap.fromTo(productInfoLayer, {
            opacity: 0
        }, {
            opacity: 1,
            scrollTrigger: {
                trigger: productInfoLayer,
                start: 'top top',
                end: `+=${windowHeight}px`,
                scrub: true
            }
        });
    }

    if (productInfoMain) {
        updateTopOffsetStickySection(productInfoMain);
        window.addEventListener('resize', debounce(() => updateTopOffsetStickySection(productInfoMain), 150));
    }
});
